import { Component, OnInit } from '@angular/core';
import { ImageBannerComponent } from '../../components/image-banner/image-banner.component';
import { ProjectCirclesComponent } from '../../includes/project-circles/project-circles.component';
import { Router, NavigationEnd } from '@angular/router';
import { SeatBeltComponent } from '../../components/seat-belt/seat-belt.component';
import { GalleryImage } from '../../models/gallery-image.model';
import { ImageModalComponent } from '../../components/image-modal/image-modal.component';
import { OrnateFrameComponent } from "../../includes/ornate-frame/ornate-frame.component";
import { MetaService } from '../../services/meta.service';

@Component({
  selector: 'pc-about-us',
  standalone: true,
  imports: [
    ImageBannerComponent,
    ProjectCirclesComponent,
    SeatBeltComponent,
    ImageModalComponent,
    OrnateFrameComponent
],
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.scss'
})
export class AboutUsComponent implements OnInit {
  // Banner Image
  bannerImgUrl: string | undefined;

  imageList: GalleryImage[] = [];
  selectedImage: GalleryImage | null = null;

  constructor(
    private router: Router,
    private metaService: MetaService,
  ) { }

  ngOnInit(): void {

    this.metaService.setMetadata('about-us');

    // Make sure we're at top of page
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    });
    
    // Banner Image
    this.bannerImgUrl = 'https://tsgblob.blob.core.windows.net/pc-haines/assets/images/about/banner';
    

    this.imageList = [
      {
        url: 'https://tsgblob.blob.core.windows.net/pc-haines/assets/images/about/team-1.webp',
        altText: 'Allenberry Resort finished lobby, a large sunlit room with wood floors, finished walls and brown furniture.',
        description: 'Description for Image 1',
        gridRowEnd: '1'
      },
      {
        url: 'https://tsgblob.blob.core.windows.net/pc-haines/assets/images/about/team-2.webp',
        altText: 'Allenberry Resort finished lobby, a large sunlit room with wood floors, finished walls and brown furniture.',
        description: 'Description for Image 1',
        gridRowEnd: '2'
      },
      {
        url: 'https://tsgblob.blob.core.windows.net/pc-haines/assets/images/about/team-3.webp',
        altText: 'Allenberry Resort finished lobby, a large sunlit room with wood floors, finished walls and brown furniture.',
        description: 'Description for Image 1',
        gridRowEnd: '2'
      },
      {
        url: 'https://tsgblob.blob.core.windows.net/pc-haines/assets/images/about/team-4.webp',
        altText: 'Allenberry Resort finished lobby, a large sunlit room with wood floors, finished walls and brown furniture.',
        description: 'Description for Image 1',
        gridRowEnd: '2'
      },
      {
        url: 'https://tsgblob.blob.core.windows.net/pc-haines/assets/images/about/team-5.webp',
        altText: 'Allenberry Resort finished lobby, a large sunlit room with wood floors, finished walls and brown furniture.',
        description: 'Description for Image 1',
        gridRowEnd: '1'
      },
      {
        url: 'https://tsgblob.blob.core.windows.net/pc-haines/assets/images/about/team-6.webp',
        altText: 'Allenberry Resort finished lobby, a large sunlit room with wood floors, finished walls and brown furniture.',
        description: 'Description for Image 1',
        gridRowEnd: '2'
      },
      {
        url: 'https://tsgblob.blob.core.windows.net/pc-haines/assets/images/about/team-7.webp',
        altText: 'Allenberry Resort finished lobby, a large sunlit room with wood floors, finished walls and brown furniture.',
        description: 'Description for Image 1',
        gridRowEnd: '2'
      },
      {
        url: 'https://tsgblob.blob.core.windows.net/pc-haines/assets/images/about/team-8.webp',
        altText: 'Allenberry Resort finished lobby, a large sunlit room with wood floors, finished walls and brown furniture.',
        description: 'Description for Image 1',
        gridRowEnd: '1'
      },
      {
        url: 'https://tsgblob.blob.core.windows.net/pc-haines/assets/images/about/team-1.webp',
        altText: 'Allenberry Resort finished lobby, a large sunlit room with wood floors, finished walls and brown furniture.',
        description: 'Description for Image 1',
        gridRowEnd: '1'
      },
      {
        url: 'https://tsgblob.blob.core.windows.net/pc-haines/assets/images/about/team-2.webp',
        altText: 'Allenberry Resort finished lobby, a large sunlit room with wood floors, finished walls and brown furniture.',
        description: 'Description for Image 1',
        gridRowEnd: '1'
      },
    ];

  }

  openModal(image: GalleryImage): void {
    this.selectedImage = image;
  }

  closeModal(): void {
    this.selectedImage = null;
  }

}